const reviewAndSubmitDescriptor = Object.freeze({
    type: 'review-and-submit',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(ReviewAndSubmit):title',
    fallbackTitle: 'Review and submit',
    defaultNavigationTitleKey: 'Page(ReceivedRequest):Component(ReviewAndSubmit):navigation-title',
    fallbackNavigationTitle: 'Review and submit',
    defaultDescriptionKey: 'Page(ReceivedRequest):Component(ReviewAndSubmit):description',
    fallbackDescription: 'Review your response before submitting it to {customer}',
    capabilities: {
        repeatable: false,
        supportedModes: ['single', 'bulk'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: [
            'request.details',
            'request.reply-documents',
            'request.other-information',
            'product.card',
            'product.concern-substances',
            'product.component-concern-substances',
            'request.declaration-approval',
        ],
        writes: [
            'request.other-information',
            'request.declaration-approval',
            'request.reply',
        ],
    },
    effects: {
        publishes: [
            'request.other-information.changed',
            'request.declaration-approval.changed',
        ],
        observes: [],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            showWorkflowReview: { type: 'boolean', default: false },
            showDeclarationDetails: { type: 'boolean', default: true },
            showIdentityConfirmation: { type: 'boolean', default: true },
            validityRequired: { type: 'boolean', default: true },
            requireAuthorization: { type: 'boolean', default: true },
            showInformationReuseConsent: { type: 'boolean', default: true },
            keepContentAfterSubmit: { type: 'boolean', default: false },
            allowResubmission: { type: 'boolean', default: false },
            showSubmittedAt: { type: 'boolean', default: true },
        },
    },
    settingsUi: {
        showWorkflowReview: { control: 'switch' },
        showDeclarationDetails: { control: 'switch' },
        showIdentityConfirmation: { control: 'switch' },
        validityRequired: { control: 'switch' },
        requireAuthorization: { control: 'switch' },
        showInformationReuseConsent: { control: 'switch' },
        keepContentAfterSubmit: { control: 'switch' },
        allowResubmission: { control: 'switch' },
        showSubmittedAt: { control: 'switch' },
    },
})

export { reviewAndSubmitDescriptor }
export default reviewAndSubmitDescriptor
